(async () => {
  class ReleatedItems extends HTMLElement {
    constructor() {
      super();
      this.productInit();
    }

    async productInit() {
      try {
        await customElements.whenDefined('releated-items');
        const productLimit = 6; // प्रदर्शित करने की चाहिए उत्पादों की संख्या
        const currentproduct = this.getAttribute('data-currentproduct');
        const currentProductColor = this.getAttribute('data-currentproductcolor');
        const thisElement = document.querySelector('#mainProductsReleatedItems');
        const urls = [
          this.getAttribute('data-productmeta1'),
          this.getAttribute('data-productmeta2'),
           this.getAttribute('data-productmeta3')
          // this.getAttribute('data-productmeta4'),
          // this.getAttribute('data-productmeta5'),
          // this.getAttribute('data-productmeta6')
        ];

        console.log('urls=>',urls);
        const fetchAsync = function (url) {
          return new Promise(function (resolve, reject) {
            fetch(url)
              .then(function (resp) { return resp.text(); })
              .then(function (data) { return resolve(data); })
              .catch(function (error) { return reject(error); });
          });
        };

        const getData = async () => {
          try {
            let displayedProducts = 0;
            const displayedProductIds = new Set(); // पहले से प्रदर्शित उत्पादों की IDs को रखने के लिए सेट बनाएं
            for (let i = 0; i < urls.length; i++) {
              const fetchResponse = await fetchAsync(urls[i]);
              const html = document.createElement('div');
              html.innerHTML = fetchResponse;
              const releatedProductItems = html.querySelector('releated-products');

              if (releatedProductItems) {
                releatedProductItems.querySelectorAll('.ul > div').forEach(elem => {
                  const elemId = elem.dataset.productId;
                  const elemColor = elem.dataset.productcolor;
                  if (elem.id == `product-${currentproduct}`) {
                    elem.remove();
                  } else if (displayedProducts < productLimit && elemColor !== currentProductColor && !displayedProductIds.has(elemId)) { // उत्पाद के ID की जाँच करें
                    thisElement.innerHTML += elem.outerHTML;
                    displayedProducts++;
                    displayedProductIds.add(elemId); // उत्पाद के ID को सेट में जोड़ें
                  }
                });
              }
            }

            if (thisElement.querySelectorAll('.product-block').length > 0) {
              document.querySelector('.collection-listing.related-items').classList.add('product-recommendations--loaded');
              console.log('products');
              if (thisElement.querySelectorAll('.product-block').length > 1) {
              // Initialize Slick Slider
              $(thisElement).slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2000,
                prevArrow: '<button class="slider-button slider-button--prev"><img src="https://cdn.shopify.com/s/files/1/0809/6109/files/Group_1878.svg?v=1718209740"> </button>',
                nextArrow: '<button class="slider-button slider-button--next"><img src="https://cdn.shopify.com/s/files/1/0809/6109/files/Group_1877.svg?v=1718209713"> </button>',
                responsive: [
                  {
                    breakpoint: 470,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
              });
  }
            } else {
              console.log('no products');
            }
          } catch (error) {
            console.log("ooops", error);
          }

        };

        getData();

        



        
      } catch (error) {
        console.log("ooops", error);
      }
    }
  }

  customElements.get('releated-items') || customElements.define('releated-items', ReleatedItems);
            
})();
